<div class="mobile-navigation-dropdown">
  <div class="mobile-navigation-dropdown__item justify-content-end">
    <app-button
      class="mobile-navigation-dropdown__close-btn"
      buttonStyle="unstyled"
      (click)="closeMenu.emit()"
    >
      <app-icon [name]="ICONS.CLOSE"></app-icon>
    </app-button>
  </div>

  <ng-container *ngFor="let item of navigationItems">
    <div
      class="mobile-navigation-dropdown__item"
      role="button"
      *ngIf="item.path"
      [routerLink]="item.path"
    >
      <app-icon *ngIf="item.icon" [name]="item.icon"></app-icon>

      {{ item.title | t }}
    </div>
  </ng-container>

  <div class="mobile-navigation-dropdown__logout" *ngIf="showLogout">
    <app-button buttonStyle="white-outlined" (click)="logout.emit()">
      {{ "logout" | t }}
    </app-button>
  </div>
</div>
